export default __webpack_public_path__ + "static/media/sofort.68a3d65a.svg";